/* eslint-disable @typescript-eslint/default-param-last */
import { GET_CAMPAIGN_SUMMARY } from '../../constants/ActionTypes';
import { ActionType } from '../../types/Interviews/interviews.types';
import { ICampaignSummaryData } from '../../types/dhwani/campaign.types';

const initialState: ICampaignSummaryData | null = null;

interface CampaignSummaryAction {
  type: string;
  payload: any;
}

/**
 * Campaign Summary Reducer
 * @param {ICampaignSummaryData | null} state
 * @param {CampaignSummaryAction} action
 * @returns {ICampaignSummaryData | null}
 */
const campaignSummaryReducer = (
  state: ICampaignSummaryData | null = initialState,
  action: CampaignSummaryAction | ActionType
): ICampaignSummaryData | null => {
  switch (action?.type) {
    case `${GET_CAMPAIGN_SUMMARY}_SUCCESS`:
      return action.payload as ICampaignSummaryData;
    case `${GET_CAMPAIGN_SUMMARY}_FAILURE`:
      return null;
    default:
      return state;
  }
};

export default campaignSummaryReducer;
